/** @return {boolean} - get is zeborne */
const isZeborne = state => {
  return state.storeCode === 'zeborne';
};

const getPaypalMethodName = state => {
  return state.paypalMethodName;
};

export default {
  isZeborne,
  getPaypalMethodName
};
